module.exports = __webpack_public_path__ + "img/checklist_v2_ger@2x.fb6cc9ab.png";